import React,{forwardRef} from 'react';

const {
    hooks: {useHover, useFocus},
    components: {generic: {Image}},
    css: {prefixCSS},
    util: {combineRefs}
} = polyphony;

const styles = {
    image: prefixCSS({
        position: 'absolute',
        objectFit: 'cover',
        width: '100%',
        height: '100%',
        transition: 'transform .1s',
        top: 0
    }),
    a: {
        display: 'block',
        width: '100%',
        height: '100%',
        position: 'relative',
        overflow: 'hidden'
    },
    childrenContainer: prefixCSS({
        height: '100%',
        width: '100%',
        position: 'absolute',
        zIndex: 10,
        display: 'flex',
        flexFlow: 'column nowrap',
        justifyContent: 'space-between',
        padding: 20,
        boxSizing: 'border-box',
        color: 'white',
        overflow: 'hidden',
        top: 0
    }),
    darklight: {
        width: '100%',
        height: '100%',
        background: "hsla(0, 0%, 20%, 0.4)",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        position: 'absolute'
    }
};

const makeXform = zoomScale => `scale3d(${zoomScale}, ${zoomScale}, ${zoomScale})`;

const HoverImageTile = forwardRef(({href, onClick, clickable=true, media, zoomScale=1.1, style, hoverEnabled=true, children, childStyle={}, hideOutline=false, ...props}, ref) => {
    let [{hover}, aref] = useHover();
    const [isFocused, fref] = useFocus();
    const imgStyles = {...styles.image};
    if (hover || isFocused) imgStyles.transform = makeXform(zoomScale);

    let attrs = {...props};
    if (hideOutline) attrs.nooutline = 'true';

    return <a {...attrs}
              ref={combineRefs([ref, aref, fref])}
              onClick={clickable ? onClick : undefined}
              href={clickable ? href : undefined}
              style={{cursor: !clickable ? 'not-allowed' : 'pointer', ...styles.a, ...style}}>
            {media && <Image lazy media={media} style={imgStyles} />}
            {hoverEnabled && !hover && <div role="none" key="darklight" style={styles.darklight} />}
            <div key="childContainer" style={{...styles.childrenContainer, ...childStyle}} role="none">{children}</div>
        </a>;
});

HoverImageTile.displayName = 'HoverImageTile';

export default HoverImageTile;

